module.exports = __webpack_public_path__ + "img/Reeses.a293c6b7.webp";